import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { outlookIntegrationsQuery } from "modules/settings/lib/outlook/outlookIntegrationsQuery"
import {
  DataResponse,
  OutlookIntegrationCallbackSchema,
  OutlookIntegrationGetTokenResponseDataSchema,
} from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof OutlookIntegrationGetTokenResponseDataSchema>>

export function useCreateOutlookIntegrationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.infer<typeof OutlookIntegrationCallbackSchema>) => {
      const response = await axios.post<Response>(`/integrations/outlook/auth`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: outlookIntegrationsQuery().queryKey })
    },
  })
}
